import { UiKitPriceBase } from '@/fo/ui/kit/price/base';
import { useMediaQuery } from '@/fo/ui/mod/media/query';
import { UiPaymentBnplBadge } from '@/fo/ui/payment/bnpl/badge';

import { ButtonBuy } from '../components/ButtonBuy/ButtonBuy';

import { styles } from './UiProductButtonBuy.styles';

export interface UiProductButtonBuyProps {
  isInCart?: boolean;
  className?: string;
  classNamePrice?: string;
  classNamePriceValue?: string;
  classNamePriceOldValue?: string;
  price: number;
  oldPrice?: number | null;
  onClick?: React.HTMLAttributes<HTMLButtonElement>['onClick'];
  loading?: boolean;
  isOutOfStock?: boolean;
  currency?: string;
  hideButton?: boolean;
  classNameYandexSplitBadge?: string;
  variantBadge?: 'simple' | 'detailed';
}

/**
 * Компонент кнопка купить для плиток
 *
 * Необходимо указать класс group/tile для всей плитки,
 * чтобы при наведении на неё кнопка купить становилась видимой
 */
export function UiProductButtonBuy({
  isInCart = false,
  className,
  classNamePrice,
  classNamePriceValue,
  classNamePriceOldValue,
  price,
  oldPrice,
  onClick,
  loading = false,
  currency,
  isOutOfStock,
  hideButton = false,
  classNameYandexSplitBadge,
  variantBadge = 'detailed'
}: UiProductButtonBuyProps) {
  const slots = styles({
    isInCart,
    variantBadge: variantBadge === 'simple' ? 'simple' : undefined
  });
  const isDesktop = useMediaQuery('xl');

  return (
    <div className={slots.base({ className, null: price === 0 })}>
      <div className={slots.priceWrapper()}>
        <UiKitPriceBase
          value={price}
          oldValue={oldPrice}
          className={slots.prices({ className: classNamePrice })}
          classNameValue={slots.price({ className: classNamePriceValue })}
          classNameOldValue={slots.oldPrice({
            className: classNamePriceOldValue
          })}
          currency={currency}
        />

        {!isOutOfStock && (
          <UiPaymentBnplBadge
            className={slots.yaSplitBadge({
              className: classNameYandexSplitBadge
            })}
            amount={price}
            size="s"
            variant={variantBadge}
            color="transparent"
            theme="light"
            align="left"
          />
        )}
      </div>

      {isDesktop && !isOutOfStock && !hideButton && (
        <ButtonBuy
          className={slots.button()}
          isInCart={isInCart}
          loading={loading}
          onClick={onClick}
        />
      )}
    </div>
  );
}
